import { z } from 'zod';
import { idSchema } from './ids';
import { CustomerStatuses } from './enums';
import {
  optionalChoice,
  optionalEmail,
  optionalText,
  optionalUrl,
  requiredText,
  versionField,
} from './fields';
import { listQuerySchema } from './list';

/** FR-CUST-005 fields. */
export const customerInputSchema = z.object({
  name: requiredText(200, 'Nosaukums ir obligāts'),
  regNr: optionalText(50),
  contactPerson: optionalText(200),
  email: optionalEmail,
  phone: optionalText(50),
  address: optionalText(300),
  website: optionalUrl,
  contractUrl: optionalUrl,
  status: optionalChoice(CustomerStatuses.schema),
  notes: optionalText(5000),
});
export type CustomerInput = z.input<typeof customerInputSchema>;

export const customerSchema = z.object({
  id: idSchema,
  name: z.string(),
  regNr: z.string().nullable(),
  contactPerson: z.string().nullable(),
  email: z.string().nullable(),
  phone: z.string().nullable(),
  address: z.string().nullable(),
  website: z.string().nullable(),
  contractUrl: z.string().nullable(),
  status: CustomerStatuses.schema.nullable(),
  notes: z.string().nullable(),
  version: z.number().int(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type Customer = z.infer<typeof customerSchema>;

export const CUSTOMER_SORT_FIELDS = ['name', 'status', 'createdAt'] as const;

export const customerListQuerySchema = listQuerySchema.extend({
  sort: z.enum(CUSTOMER_SORT_FIELDS).default('name'),
  status: CustomerStatuses.schema.optional(),
});
export type CustomerListQuery = z.infer<typeof customerListQuerySchema>;

/** Optimistic concurrency (ADR 0006): updates carry the version they were based on. */
export const customerUpdateSchema = customerInputSchema.extend(versionField);

/** A customer in a select (projects, support) — every customer, A→Z, no paging. */
export const customerOptionSchema = z.object({ id: idSchema, name: z.string() });
export type CustomerOption = z.infer<typeof customerOptionSchema>;
